import React, { useEffect, useId, useState } from 'react';
import MapView from '@arcgis/core/views/MapView';
import EsriMap from '@arcgis/core/Map';
import { disableZooming } from './utils';
import type Basemap from '@arcgis/core/Basemap';
import { USAExtent } from './extents';
import Extent from '@arcgis/core/geometry/Extent';

interface StaticMapProps {
  onLoad?: (view: MapView) => void;
  basemap?: Basemap | string;
  extent?: Extent | object;
}
/**
 * A minimal ArcGIS MapView component that renders a static, non-interactive map with a specified basemap and extent, supporting onLoad callbacks for external layer registration.
 */
const StaticMap = ({ onLoad, basemap = 'hybrid', extent = USAExtent }: StaticMapProps) => {
  const mapId = useId();
  const [, setView] = useState<MapView>();
  useEffect(() => {
    const map = new EsriMap({ basemap });
    const view = new MapView({
      container: mapId,
      extent,
      map,
      ui: {
        components: []
      },
      constraints: {
        rotationEnabled: false
      }
    });

    setView(view);
    view.when(disableZooming).then();
    if (onLoad) {
      view.when(onLoad).then();
    }
    return () => {
      view?.destroy();
    };
  }, []);

  return <div id={mapId} style={{ height: '100%', width: '100%' }} />;
};

export default StaticMap;
